import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { GlobalComponent } from '../global/global.component';
import { SeoService } from '../service/seo.service';

@Component({
  selector: 'login-forbuyer',
  templateUrl: './forbuyer.component.html',
  styleUrls: ['./forbuyer.component.scss']
})
export class ForbuyerComponent implements OnInit {
  
  
  hostName = GlobalComponent.hostName;
  

  constructor(private router: Router,private SEOService:SeoService) { 

    
  }

  ngOnInit(){
    window.scroll(0,0);
    this.SEOService.updateCanonicalUrl(this.hostName + '/buyersbenefits');
    
  }

  signup() {
    this.router.navigate(['login/signup']);
  }

   
  
   
}



